module.exports = __webpack_public_path__ + "img/three-pointers.0f163251.svg";